<div class="wrapper">
  <div class="row table-toolbar">
    <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12">
      <div class="upload-wrapper">
        <button (click)="loadUserFiles(user_details?.user_id)">Refresh Files</button>
        <form (ngSubmit)="onSubmit()">
          <div *ngIf="errorMessage" class="error-message">
            <p style="color: red; font-weight: bold;">{{ errorMessage }}</p>
          </div>
          <div class="row">
            <!-- Aadhar Card -->
            <!-- <div class="file-upload-section col-md-4">
              <div class="upload-box">
                <label for="aadharCard">Aadhar Card <span style="color: red;">*</span></label>
                <input
                  type="file"
                  id="aadharCard"
                  accept=".png, .jpg, .jpeg"
                  (change)="onFileChange($event, '1')"
                />
                <div class="file-preview" *ngIf="uploadedFiles['aadharCard']">
                  <a
                    [href]="uploadedFiles['aadharCard'].url"
                    target="_blank"
                    >{{ uploadedFiles['aadharCard'].name }}</a
                  >
                </div>
              </div>
            </div> -->
            <div class="file-upload-section col-md-2" style="border: 1px solid #ccc; padding: 10px 0px 10px 5px; margin-bottom: 10px; margin-right: 10px;">
              <div class="upload-box">
                <label for="aadharCard">Photo <span style="color: red;">*</span></label>
                <input
                  type="file"
                  id="aadharCard"
                  accept=".png, .jpg, .jpeg"
                  (change)="onFileChange($event, '7')"
                />
                <div class="file-preview" *ngIf="uploadedFiles['7']">
                  <p><strong>Uploaded File:</strong></p>
                  <a
                    [href]="uploadedFiles['7'].url"
                    target="_blank"
                  >
                    {{ uploadedFiles['7'].name }}
                  </a>
                </div>
              </div>
            </div>
            <div class="file-upload-section col-md-3" style="border: 1px solid #ccc; padding: 10px 0px 10px 5px; margin-bottom: 10px; margin-right: 10px;">
              <div class="upload-box">
                <label for="aadharCard">Aadhar Card <span style="color: red;">*</span></label>
                <input
                  type="file"
                  id="aadharCard"
                  accept=".png, .jpg, .jpeg"
                  (change)="onFileChange($event, '1')"
                />
                <div class="file-preview" *ngIf="uploadedFiles['1']">
                  <p><strong>Uploaded File:</strong></p>
                  <a
                    [href]="uploadedFiles['1'].url"
                    target="_blank"
                  >
                    {{ uploadedFiles['1'].name }}
                  </a>
                </div>
              </div>
            </div>

            <!-- Pan Card -->
            <div class="file-upload-section col-md-3" style="border: 1px solid #ccc; padding: 10px 0px 10px 5px; margin-bottom: 10px; margin-right: 10px;">
              <div class="upload-box">
                <label for="panCard"> Pan Card  <span style="color: red;">*</span></label>
                <input
                  type="file"
                  id="panCard"
                  accept=".png, .jpg, .jpeg"
                  (change)="onFileChange($event, '2')"
                />
                <div class="file-preview" *ngIf="uploadedFiles['2']">
                  <p><strong>Uploaded File:</strong></p>
                  <a
                    [href]="uploadedFiles['2'].url"
                    target="_blank"
                    >{{ uploadedFiles['2'].name }}</a
                  >
                </div>
              </div>
            </div>

            <!-- Relieving Letter -->
            <div class="file-upload-section col-md-3" style="border: 1px solid #ccc; padding: 10px 0px 10px 5px; margin-right: 10px; margin-bottom: 10px;">
              <div class="upload-box">
                <label for="relievingLetter">Relieving Letter</label>
                <input
                  type="file"
                  id="relievingLetter"
                  accept=".png, .jpg, .jpeg"
                  (change)="onFileChange($event, '3')"
                />
                <div class="file-preview" *ngIf="uploadedFiles['3']">
                  <p><strong>Uploaded File:</strong></p>
                  <a
                    [href]="uploadedFiles['3'].url"
                    target="_blank"
                    >{{ uploadedFiles['3'].name }}</a
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Passport -->
            <div class="file-upload-section col-md-3" style="border: 1px solid #ccc; padding: 10px; margin-bottom: 10px;margin-right: 10px;">
              <div class="upload-box">
                <label for="passport">Passport</label>
                <input
                  type="file"
                  id="passport"
                  accept=".png, .jpg, .jpeg"
                  (change)="onFileChange($event, '4')"
                />
                <div class="file-preview" *ngIf="uploadedFiles['4']">
                  <p><strong>Uploaded File:</strong></p>
                  <a
                    [href]="uploadedFiles['4'].url"
                    target="_blank"
                    >{{ uploadedFiles['4'].name }}</a
                  >
                </div>
              </div>
            </div>

            <!-- Bank Details -->
            <div class="file-upload-section col-md-3" style="border: 1px solid #ccc; padding: 10px; margin-bottom: 10px;margin-right: 10px;">
              <div class="upload-box">
                <label for="bankDetails">Bank Details</label>
                <input
                  type="file"
                  id="bankDetails"
                  accept=".png, .jpg, .jpeg"
                  (change)="onFileChange($event, '5')"
                />
                <div class="file-preview" *ngIf="uploadedFiles['5']">
                  <p><strong>Uploaded File:</strong></p>
                  <a
                    [href]="uploadedFiles['5'].url"
                    target="_blank"
                    >{{ uploadedFiles['5'].name }}</a
                  >
                </div>
              </div>
            </div>

            <!-- Salary Statements -->
            <div class="file-upload-section col-md-3" style="border: 1px solid #ccc; padding: 10px; margin-bottom: 10px; margin-right: 10px;">
              <div class="upload-box">
                <label for="salaryStatements">Salary Statements</label>
                <input
                  type="file"
                  id="salaryStatements"
                  accept=".png, .jpg, .jpeg"
                  (change)="onSalaryStatementsChange($event)"
                  multiple
                />
                <div class="file-preview" *ngIf="uploadedFiles['6']?.length > 0">
                  <p><strong>Uploaded Files (Last 3):</strong></p>
                  <ul>
                    <li *ngFor="let file of uploadedFiles['6'] | slice:-3">
                      <a [href]="file.url" target="_blank">{{ file.name }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
          </div>

          <!-- Submit All Button -->
          <div class="button-wrapper">
            <button type="submit" mat-raised-button color="primary">
              Submit All
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
